(function () {
  'use strict';

  /**
   * Pinterest AddToCart Event Tracking
   *
   * Intercepts two code paths used by the Ella theme:
   *   1. Shopify.addItem  – jQuery AJAX, defined in global.js (actionAddToCart)
   *   2. window.fetch     – native fetch, used by product-form component (actionAddToCart2)
   *
   * Currency priority: Shopify.currency.active → window.shop_currency → 'USD'
   */

  function getCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      ? window.Shopify.currency.active
      : (window.shop_currency || 'USD');
  }

  function firePinterestAddToCart(lineItem) {
    if (typeof pintrk !== 'function') return;
    if (!lineItem || (!lineItem.variant_id && !lineItem.id)) return;
    pintrk('track', 'addtocart', {
      event_id: 'addtocart_' + Date.now(),
      value: parseFloat((lineItem.price / 100).toFixed(2)),
      order_quantity: lineItem.quantity,
      currency: getCurrency()
    });
  }

  // ── Path 1: Shopify.addItem (jQuery AJAX) ────────────────────────────────
  function wrapShopifyAddItem() {
    if (typeof Shopify === 'undefined' || typeof Shopify.addItem !== 'function') return;
    var _orig = Shopify.addItem;
    Shopify.addItem = function (variant_id, quantity, $target, callback, input) {
      var wrappedCb = function (line_item) {
        firePinterestAddToCart(line_item);
        if (typeof callback === 'function') callback(line_item);
      };
      _orig.call(this, variant_id, quantity, $target, wrappedCb, input);
    };
  }

  // ── Path 2: window.fetch (product-form component) ────────────────────────
  // Clone the Response before the caller reads it to avoid "body already used" errors.
  function wrapFetch() {
    if (typeof window.fetch !== 'function') return;
    var _origFetch = window.fetch;
    window.fetch = function (url, options) {
      var isCartAdd = typeof url === 'string' && url.indexOf('cart/add.js') !== -1;
      if (isCartAdd && options && options.method === 'POST') {
        return _origFetch.apply(this, arguments).then(function (response) {
          response.clone().json().then(function (lineItem) {
            firePinterestAddToCart(lineItem);
          }).catch(function () {});
          return response;
        });
      }
      return _origFetch.apply(this, arguments);
    };
  }

  // global.js and theme.js are both loaded with defer, so Shopify.addItem is
  // defined before DOMContentLoaded. Guard against edge cases anyway.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapShopifyAddItem);
  } else {
    wrapShopifyAddItem();
  }

  // Patch fetch immediately (before any user interaction).
  wrapFetch();
})();
